import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtils} from '../shared/http.utils';
import {BasicFilters} from "../model/filters/basic-filters";
import {DefaultDeviceCategoryFilters} from "../model/filters/default-device-category-filters";
import {DefaultDeviceCategoryPersistRequest} from "../model/requests/default-device-category-persist-request";

@Injectable({
  providedIn: 'root'
})
export class DefaultDeviceCategoriesService {

  private readonly defaultDeviceCategoriesURL: string;

  constructor(private http: HttpClient) {
    this.defaultDeviceCategoriesURL = '/catalog/default_device_categories';
  }

  public getDefaultDeviceCategories(offset?: number, limit?: number, filters?: DefaultDeviceCategoryFilters): Observable<any> {
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    const body = (filters != null) ? filters : new BasicFilters();
    return this.http.post<any>(this.defaultDeviceCategoriesURL, body, options);
  }

  public getDefaultDeviceCategory(name: string): Observable<any> {
    const url = `${this.defaultDeviceCategoriesURL}/${name}`;
    return this.http.get<any>(url);
  }

  public createDefaultDeviceCategory(defaultDeviceCategoryCreationData: DefaultDeviceCategoryPersistRequest): Observable<any> {
    const url = `${this.defaultDeviceCategoriesURL}/create`;
    return this.http.post<any>(url, defaultDeviceCategoryCreationData);
  }

  public editDefaultDeviceCategory(defaultDeviceCategoryEditionData: DefaultDeviceCategoryPersistRequest): Observable<any> {
    const url = `${this.defaultDeviceCategoriesURL}/edit`;
    return this.http.post<any>(url, defaultDeviceCategoryEditionData);
  }

  public deleteDefaultDeviceCategory(name: string): Observable<HttpResponse<any>> {
    const url = `${this.defaultDeviceCategoriesURL}/${name}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

  public deleteDefaultDeviceCategories(names: string[]): Observable<HttpResponse<any>> {
    const url = `${this.defaultDeviceCategoriesURL}/delete`;
    return this.http.post<any>(url, names, {observe: 'response'});
  }

}
